import fr from './data.js'

/**
 *  劫持 'history.pushState', 确保每次调用都能在e.state里种入一个时间戳，
 *  以根据这些时间戳来方便地判断每次路由变更的方向
 */
history._pushState = history.pushState
history.pushState = function (state, title, url) {
    state = state || {}
    state.vxkey = Date.now()
    history._pushState(state, title, url);
}

/**
 * 重写 'history.go' 方法
 */
history._go = history.go
history.go = function (num) {
    let apiName = num > 0 ? "forward" : "back"
    num = Math.abs(num)
    for (let i = 0; i < num; i++) {
        // 解决ios不能快速的前进后退
        setTimeout(() => {
            history[apiName]()
        }, 40 * i)
    }
}


// vue-router 3以上版本，在程序里调用push,replace这两个API改变路由时，是不会触发此事件的。
// 路由方向的判断, "前进 > forward" "后退 > back"
window.addEventListener('popstate', e => {
    // console.log("-------------------------------------------");
    // console.log("window popstate event .....", e);

    fr.routeMode = "";

    // 说明是通过浏览器的"前进"、"后退"按键操作的，
    // 或者是通过调用go,back,forward方法改变的路由
    fr.direction = !e.state || (e.state.vxkey - fr.curKey > 0) > 0 ? 'forward' : 'back'
})

export default {
    data() {
        return {
            fr,
        }
    },
    methods: {
        // 获取当前页面的 history.state.vxkey
        getCurHistoryStateKey() {
            // 如果才开始进行应用，并且还没有第一个history.state时，主动生成一个来替换当前history的记录
            if (!history.state || !history.state.vxkey) {
                history.replaceState({
                        vxkey: Date.now(),
                    },
                    "",
                    location.href
                );
            }

            // 相当关键，自定义路由实现的关键节点
            fr.prevKey = fr.curKey
            fr.curKey = history.state.vxkey;
        }
    },
    watch: {
        $route(to, from) {
            // console.log(this.fr.direction);
            this.getCurHistoryStateKey()
        }
    },
}